import { useState } from "react";
import axios from "axios";
import { API } from "../../App";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("token", res.data.access_token);
      toast.success("Erfolgreich angemeldet");
      window.location.href = "/admin/dashboard";
    } catch {
      toast.error("Anmeldung fehlgeschlagen");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Side - Login Form */}
      <div className="w-full lg:w-1/2 bg-[#D32F2F] flex flex-col justify-center items-center p-8 lg:p-16">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="mb-12">
            <img 
              src="https://customer-assets.emergentagent.com/job_betonbau-cms/artifacts/ybiq5sq0_logo.png" 
              alt="Gashi Bau GmbH" 
              className="h-16"
            />
          </div>

          {/* Welcome Text */}
          <div className="mb-8">
            <h1 className="text-3xl lg:text-4xl font-bold text-white mb-2" style={{ fontFamily: "Barlow" }}>
              Willkommen zurück
            </h1>
            <p className="text-white/80 text-lg" style={{ fontFamily: "Manrope" }}>
              Bitte melden Sie sich an, um fortzufahren
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-white/90 text-sm font-medium mb-2">E-Mail Adresse</label>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                className="w-full bg-white/10 border border-white/30 text-white placeholder-white/50 rounded-lg px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
                placeholder="admin@gashi-betonbau.de"
                required 
              />
            </div>
            <div>
              <label className="block text-white/90 text-sm font-medium mb-2">Passwort</label>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className="w-full bg-white/10 border border-white/30 text-white placeholder-white/50 rounded-lg px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
                placeholder="••••••••"
                required 
              />
            </div>
            <button 
              type="submit" 
              disabled={loading} 
              className="w-full bg-[#0A2A43] text-white py-4 rounded-lg font-semibold text-lg hover:bg-[#0A2A43]/90 disabled:opacity-50 transition-all shadow-lg hover:shadow-xl"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Anmelden...
                </span>
              ) : "Anmelden"}
            </button>
          </form>

          {/* Back Link */}
          <div className="mt-8 text-center">
            <a href="/" className="text-white/70 hover:text-white text-sm transition-colors flex items-center justify-center gap-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Zurück zur Website
            </a>
          </div>
        </div>
      </div>

      {/* Right Side - Image */}
      <div className="hidden lg:block lg:w-1/2 relative">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: "url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-[#0A2A43]/60"></div>
        </div>
        
        {/* Overlay Content */}
        <div className="relative h-full flex flex-col justify-end p-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "Barlow" }}>
              Admin-Bereich
            </h2>
            <p className="text-white/80" style={{ fontFamily: "Manrope" }}>
              Verwalten Sie Ihre Website-Inhalte, Leistungen, Projekte und mehr.
            </p>
            <div className="flex gap-4 mt-4">
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <svg className="w-5 h-5 text-[#D32F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Slider verwalten
              </div>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <svg className="w-5 h-5 text-[#D32F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Leistungen
              </div>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <svg className="w-5 h-5 text-[#D32F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Anfragen
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
